import { OfferReturn } from "@/api/offers";
import { useActiveStore } from "@/store/activePages";
import { useFormStore } from "@/store/form";
import { setMarketingInfo } from "@/utils/saleSessionStorage";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";

export const ProductPage = ({ offer, ofertaSlug }: { offer: OfferReturn; ofertaSlug: string }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const addData = useFormStore((store) => store.addData);
  const clearFormStore = useFormStore((store) => store.clearFormStore);
  const addPage = useActiveStore((store) => store.addPage);
  const clearPages = useActiveStore((store) => store.clearPages);

  useEffect(() => {
    clearFormStore();
    clearPages();
  }, [clearFormStore, clearPages]);

  useEffect(() => {
    if (searchParams) {
      const search: { [key: string]: string } = {};
      searchParams.forEach((value, key) => {
        search[key] = value;
      });

      if (searchParams.get("utm_source")) {
        setMarketingInfo(search);
      }

      addData(search);
    }
  }, [addData, searchParams]);

  useEffect(() => {
    Cookies.set("offer", JSON.stringify(offer), {
      secure: import.meta.env.VITE_LOCAL === "production",
      sameSite: "strict",
      path: "/",
      expires: new Date(Date.now() + 1000 * 60 * 60 * 24),
    });

    addPage("/personal-data");
    addData({ ofertaSlug });
    navigate("/personal-data");
  }, [addPage, addData, offer, ofertaSlug, navigate]);

  return null;
};
